export default __webpack_public_path__ + "static/media/carImg.6d68dcf7.JPG";